import React from "react";
import { Outlet } from "react-router-dom";
export const MobileTransfer: React.FC = () => {
  return <Outlet />;
};
